import React, { useRef, useState } from 'react';
import { InjectedSearchProps } from 'react-bootstrap-table2-toolkit';
import Input from '../input';

function TableSearch({ onSearch, searchText }: InjectedSearchProps) {
    const [value, setValue] = useState(searchText);

    const texting = useRef(false);

    const onClickHandler = (v?:string) => {
        if (typeof onSearch === 'function') {
            onSearch(v ?? value);
        }
    };

    const onChange = (v: string) => {
        if (!texting.current) {
            onClickHandler(v);
        }
        setValue(v);
        texting.current = false;
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        texting.current = true;
        if (e.code === 'Enter') {
            onClickHandler();
        }
    };

    return (
        <div className="col-12 mt-2 mt-md-0 col-md-4 d-flex">
            <Input
                dataIndex=""
                type="input"
                placeholder="Поиск..."
                value={value}
                options={{ type: 'search' }}
                onKeyDown={onKeyDown}
                onChange={onChange}
            />
            <button
                className="btn btn-secondary ml-2"
                type="button"
                onClick={() => onClickHandler()}
            >
                Поиск
            </button>
        </div>
    );
}

export default TableSearch;
